import React, { Fragment, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import UseAlertMessageState from '../../../control/alert/UseAlertMessageState';
import UseLoadingState from '../../../control/loading/UseLoadingState';
import AlertMessage from '../../../control/alert/AlertMessage';
import Loading from '../../../control/loading/Loading';
import { FormHelperText, IconButton, InputAdornment } from '@material-ui/core';
import { Button } from 'antd';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '24px',
    },
    rootPaper: {
        width: '100%',
        ...theme.paperPadding,
    },
    divider: {
        backgroundColor: theme.mainTheme.color1,
    },
    labelStyle: {
        color: theme.mainTheme.color1,
        fontSize: 20,
    },
    labelRequiredStyle: {
        paddingLeft: 4,
        color: theme.mainTheme.color5,
    },
    // normalTextFields: {
    //     '& input': {
    //         height: theme.field.height,
    //         padding: theme.field.padding,
    //         fontSize: theme.fontSize.body1,
    //     },
    // },
    footer: {
        paddingTop: 24,
    },
    btnCancel: {
        backgroundColor: '#808080 !important',
    },
    inputRoot: {
        paddingLeft: 0,
        fontSize: 16,
        paddingRight: 0,
        '& .MuiInputBase-input': {
            padding: 0,
            height: '37px',
        },
        '& .MuiOutlinedInput-root': {
            paddingLeft: 0,
        },
    },
    hidden: {
        display: 'none',
    },
    uploadBtn: {
        height: '37px',
        border: 'none',
        borderRight: '1px solid #BDBDBD',
        borderRadius: '0',
        fontSize: '16px',
        fontWeight: '400',
        '&:hover': {
            color: 'black',
            backgroundColor: '#fff',
            borderColor: 'black',
        },
        '&:active': {
            color: 'black',
            backgroundColor: '#fff',
            borderColor: 'black',
        },
        '&:focus': {
            color: 'black',
            backgroundColor: '#fff',
            borderColor: 'black',
        },
        '--antd-wave-shadow-color': 'transparent',
    },
    iconBtn: {
        height: '12px',
        width: '12px',
        padding: '0px',
        paddingTop: '2px',
        paddingBottom: '2px',
        paddingLeft: '10px',
        color: 'black !important',
        fontSize: '16px',
    },
    formHelper: {
        color: theme.mainTheme.color5,
        marginTop: '1px',
        marginLeft: '10px',
    },
    hasFileHelperText: {
        color: theme.mainTheme.color1,
        fontSize: 20,
        marginTop: '10px',
    },
    hasFileAnchorUrl: {
        textDecoration: 'underline !important',
        textDecorationThickness: '1px !important',
        textUnderlineOffset: '2px !important',
    },
    buttonDeleteExists: {
        padding: '4px',
    },
    asterisk: {
        color: theme.mainTheme.color5,
    },
}));

const MAX_FILE_SIZE = 5000000; // Bytes

const UploadExcelPreRegister = (props) => {
    const {
        templateURL,
        handleChangeExcelFile,
        reserveFile,
        fieldError,
        isPublic,
    } = props;
    const inputFileRef = useRef(null);
    const classes = useStyles();
    const alertMessageState = UseAlertMessageState();
    const loadingState = UseLoadingState();
    const [currentValue, setCurrentValue] = useState({
        boundaryFileName: null,
        buffer: null,
    });
    const [file, setFile] = useState(null);
    const [fileError, setFileError] = useState('');

    const handleFileChange = (event) => {
        validateFile(event.target.files[0]);
    };

    const validateFile = (file) => {
        if (!file) {
            setFile(null);
            setFileError('');
            handleChangeExcelFile(null);
            return true;
        } else if (file.size > MAX_FILE_SIZE) {
            setFile(null);
            setFileError('ขนาดของไฟล์ต้องไม่เกิน 5 MB');
            setCurrentValue((prev) => ({
                ...prev,
                boundaryFileName: file.name,
            }));
            handleChangeExcelFile(null);
            return false;
        } else if (file && file.name.endsWith('.xlsx')) {
            setFile(file);
            setFileError('');
            setCurrentValue((prev) => ({
                ...prev,
                boundaryFileName: file.name,
            }));
            handleChangeExcelFile(file);
            return true;
        } else {
            setFile(null);
            setFileError('รองรับไฟล์นามสกุล .xlsx เท่านั้น');
            setCurrentValue((prev) => ({
                ...prev,
                boundaryFileName: file.name,
            }));
            handleChangeExcelFile(file);
            return false;
        }
    };

    const handleClickRemoveFile = () => {
        setFile(null);
        setFileError(null);
        setCurrentValue((prev) => ({
            ...prev,
            boundaryFileName: '',
        }));
        handleChangeExcelFile(null);
        inputFileRef.current.value = null;
    };

    return (
        <Fragment>
            <Typography className={classes.labelStyle}>
                {'อัปโหลดไฟล์รายชื่อลงทะเบียนล่วงหน้า (.xlsx)'}
                {!isPublic && <span className={classes.asterisk}>*</span>}
                {'\u00A0'}
                <a
                    href={templateURL} //some template url open blank to download
                    style={{
                        textDecoration: 'underline',
                        textDecorationThickness: '1px',
                        textUnderlineOffset: '2px',
                    }}
                >
                    ดาวน์โหลดไฟล์เทมเพลต
                </a>
            </Typography>
            <TextField
                className={classes.hidden}
                type="file"
                onChange={handleFileChange}
                variant="outlined"
                fullWidth
                inputProps={{
                    ref: inputFileRef,
                    accept: '.xlsx',
                }}
            />
            <TextField
                variant="outlined"
                fullWidth
                placeholder="กรุณาเลือกไฟล์"
                InputProps={{
                    classes: {
                        root: classes.inputRoot,
                    },
                    readOnly: true,
                    startAdornment: (
                        <InputAdornment position="start">
                            <Button
                                className={classes.uploadBtn}
                                variant="contained"
                                color="primary"
                                onClick={() => inputFileRef.current.click()}
                            >
                                Choose file
                            </Button>
                        </InputAdornment>
                    ),
                    endAdornment: currentValue.boundaryFileName && (
                        <IconButton onClick={handleClickRemoveFile}>
                            <DeleteIcon
                                color="primary.dark"
                                style={{ fontSize: 17 }}
                            />
                        </IconButton>
                    ),
                }}
                value={currentValue.boundaryFileName}
                error={!!fileError}
                helperText={fileError}
            />
            {reserveFile &&
                typeof reserveFile === 'object' &&
                reserveFile.hasOwnProperty('url') && (
                    <div className={classes.hasFileHelperText}>
                        ไฟล์ที่อัปโหลดปัจจุบัน:{'\u00A0'}{' '}
                        <span>
                            <a
                                className={classes.hasFileAnchorUrl}
                                href={reserveFile.url}
                            >
                                {reserveFile.name}
                            </a>
                        </span>
                        <IconButton
                            aria-label="delete"
                            className={classes.buttonDeleteExists}
                            onClick={() => handleClickRemoveFile()}
                        >
                            <DeleteIcon
                                style={{ fontSize: 17, color: '#ff0404' }}
                            />
                        </IconButton>
                    </div>
                )}
            <AlertMessage {...alertMessageState.altProps} />
            <Loading isShowLoading={loadingState.isShowLoading} />
            {fieldError && (
                <FormHelperText className={classes.formHelper}>
                    {fieldError}
                </FormHelperText>
            )}
        </Fragment>
    );
};

export default UploadExcelPreRegister;
